import { parseFromWebStream } from "@discoveryjs/json-ext";

export const useImportJson = () => {
  function formatFileSize(bytes: number, decimalPoint?: number) {
    if (bytes == 0) return "0 Bytes";
    const k = 1000,
      dm = decimalPoint || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const loadFile = async (file: File): Promise<any> => {
    return new Promise((resolve, reject) => {
      const size = formatFileSize(file.size);

      if (size.includes("GB") && parseFloat(size) > 2) {
        reject(new Error("File size greater than 2GB is not supported"));
      }

      const readStream = file.stream();

      parseFromWebStream(readStream)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  };

  return loadFile;
};
